import { Input } from "../ui/input";
import { Label } from "../ui/label";

export const inputCls = "h-11 rounded-xl bg-white/[0.04] border-white/10 text-white placeholder:text-[#8f8cc0] focus-visible:ring-2 focus-visible:ring-[#5b5fd6] focus-visible:ring-offset-0 focus-visible:border-transparent transition-colors hover:border-white/20";

export const Field = ({ label, id, hint, ...props }) => (
  <div className="space-y-2">
    <Label htmlFor={id} className="text-[#c9c6f0] text-[11px] font-semibold uppercase tracking-[0.14em]">{label}</Label>
    <Input id={id} className={inputCls} {...props} />
    {hint && <p className="text-xs text-[#a4a6ff]">{hint}</p>}
  </div>
);

export const SaveBtn = ({ busy, children = "Kaydet", ...props }) => (
  <button type="submit" disabled={busy} {...props}
    className="inline-flex items-center justify-center gap-2 rounded-xl bg-gradient-to-b from-[#6c70ff] to-[#5b5fd6] px-6 h-11 font-semibold shadow-[0_8px_30px_rgba(91,95,214,0.35)] hover:brightness-110 active:scale-[0.98] transition-[filter,transform] disabled:opacity-60">
    {busy ? "Kaydediliyor..." : children}
  </button>
);

export const GhostBtn = ({ children, className = "", ...props }) => (
  <button type="button" {...props}
    className={`inline-flex items-center justify-center gap-2 rounded-xl border border-white/10 bg-white/[0.04] px-5 h-11 font-semibold hover:bg-white/[0.08] hover:border-white/20 transition-colors ${className}`}>
    {children}
  </button>
);

export const Panel = ({ children, className = "" }) => (
  <div className={`rounded-2xl border border-white/[0.08] bg-white/[0.03] backdrop-blur-xl p-6 md:p-7 shadow-[0_1px_0_rgba(255,255,255,0.04)_inset] ${className}`}>{children}</div>
);
